<template>
  <div class="w-full">
    <TopAppBarDrawer
      :isDrawerOpen="isDrawerOpen"
      @closeDrawer="closeDrawer"
    ></TopAppBarDrawer>
    <header
      class="mdc-top-app-bar"
      id="app-bar"
      ref="appBar"
      :class="staticMode ? 'position-static' : 'mdc-top-app-bar--fixed'"
      v-if="!isLearn"
    >
      <div class="mdc-top-app-bar__row">
        <section
          class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start"
        >
          <a
            class="material-icons mdc-top-app-bar__navigation-icon "
            id="drower_id"
            @click="openDrawer()"
            v-if="leftBtnMode === 'menu'"
            >{{ leftBtnMode }}</a
          >
          <a
            class="material-icons mdc-top-app-bar__navigation-icon"
            @click="leftBtnMethod"
            v-else
            >{{ leftBtnMode }}</a
          >
        </section>

        <section class="mdc-top-app-bar__section title">
          <div v-if="isMain" class="mdc-top-app-bar__title main_title_logo__wrapper">
            <img src="@/assets/main/With_Blue.svg" alt="main_icon" class="main_title_logo" />
          </div>
          <div v-else class="mdc-top-app-bar__title">{{ title }}</div>
        </section>

        <section
          class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end"
        >
          <a
            class="material-icons mdc-top-app-bar__action-item"
            aria-label="search"
            alt="search"
            v-if="!rightBtnTxt"
            @click="rightBtnMethod"
            >{{ rightBtnMode }}</a
          >

          <span
            class="confirm-btn"
            v-if="rightBtnTxt"
            @click="rightBtnTxtMethod"
          >
            {{ rightBtnTxt }}
          </span>
        </section>
      </div>
      <component :is="selectedTabBar"></component>
    </header>
    <header v-else>
      <component :is="selectedTabBar"></component>
    </header>
  </div>
</template>

<style scoped>
.confirm-btn {
  color: var(--LogoBlue) !important;
  padding-right: 1rem;
}
</style>

<script>
/**
 * 메뉴별 메인 컴포넌트용 앱바 컴포넌트(Appbar Components for Main Components by Menu)
 *
 * @author minkyoung.park@emcast.com
 */
// Components/Mixin/Extend/API define
import { MDCTopAppBar } from "@material/top-app-bar";
import { topAppBarMixin } from "../mixins/topAppBar.js";
import TopAppBarDrawer from "./TopAppBarDrawer.vue";

export default {
  components: {
    DegreeList: () => import("./TopAppBarDegreeListTab.vue"),
    LearnList: () => import("./TopAppBarLearnListTab.vue"),
    ExamList: () => import("./TopAppBarExamListTab.vue"),
    SurveyList: () => import("./TopAppBarSurveyListTab.vue"),
    PrizeRequest: () => import("./TopAppBarPrizeRequest.vue"),
    RewardBadgeList: () => import("./TopAppBarRewardListTab.vue"),
    TopAppBarDrawer,
  },

  props: [
    "leftBtnMode",
    "rightBtnMode",
    "title",
    "leftBtnMethod",
    "rightBtnMethod",
    "staticMode",
    "rightBtnTxt",
    "rightBtnTxtMethod",
  ],

  data() {
    return {
      isDrawerOpen: false,
    };
  },

  computed: {
    selectedTabBar() {
      console.log(this.$route.meta.TabType)
      return this.$route.meta.TabType;
    },
    isMain() {
      if (this.$route.name.toLowerCase() === "main") return true;
      return false;
    },
    isLearn() {
      if(this.$route.name.toLowerCase() === "learn") return true;
      return false;
    }
  },

  mounted() {
    this.topAppBar = MDCTopAppBar.attachTo(
      document.querySelector(".mdc-top-app-bar")
    );

    if (("setPetern", localStorage.getItem("setPetern"))) {
      setTimeout(function () {
        document.getElementById("drower_id").click();
        localStorage.removeItem("setPetern");
      }, 1000);
    }
  },

  methods: {
    // Open drawer
    openDrawer() {
      this.isDrawerOpen = true;
    },
    // Close drawer
    closeDrawer() {
      this.isDrawerOpen = false;
    },
  },
};
</script>

<style scoped>
  #app-bar {
    background-color: white;
  }
  .main_title_logo__wrapper {
    width: 100%;
    height: 100%;
  }
  .main_title_logo {
    width: 100%;
    height: 100%;
    object-fit: contain;
    padding: 12px;
  }
</style>